import { PlansApi } from '../api/PlansApi'
import { Plan } from '../core/Plan'

export const plansStore = {
	state: {
    	plans: null,
    	loading: false,
    	loadingPromise: null,
    	selectedPlanId: null
	},

	loadPlans () {
		// don't load if alredy started loading
		if (this.state.loading) return this.loadingPromise

		// don't load if already loaded
		if (this.state.plans) return Promise.resolve()

		this.state.loading = true

		var pm = new PlansApi()
		this.loadingPromise = pm.get({})

		.then(response => {
			this.state.plans = []
		    response.body.data.resources.forEach(plan => { this.state.plans.push(new Plan(plan)) })

			this.state.loading = false
		})

		.catch(response => {
			this.state.loading = false
			return response
		})

		return this.loadingPromise;
	},

	getPlan (people, meals) {
		// parseInt here because it arrives from cookie as string
		return this.state.plans.find(p => p.people === parseInt(people) && p.meals === parseInt(meals))
	},

	getPeople (vars) {
		if (!this.state.plans) return
		var plan = this.state.plans.find(p => p.id === vars.plan_id)
		return plan && plan.people
	},

	getMeals (vars) {
		if (!this.state.plans) return
		var plan = this.state.plans.find(p => p.id === vars.plan_id)
		return plan && plan.meals
	},

	findPlan (params) {
		if (!params) return	Promise.resolve()	
		var plan = this.state.plans.find(p => p.people === params.people && p.meals === params.meals)

		// take the first plan with people quantity
		var p = this.state.plans.find(p => p.people === params.people)
		var error = `invalid meals quantity`

		return plan ? Promise.resolve(plan) : Promise.reject(new Error(error))
	},

	getMaxRecipes (params) {
		if (!params.plan_id || !this.state.plans) return

		var people = this.getPeople({ plan_id: params.plan_id})
		var max = Math.max(...this.state.plans.filter(plan => plan.people === people).map(r => r.meals))
		return max
	},

	getMinRecipes (params) {
		if (!params.plan_id || !this.state.plans) return

		var people = this.getPeople({ plan_id: params.plan_id})
		var min = Math.min(...this.state.plans.filter(plan => plan.people === people).map(r => r.meals))
		return min
	}
}